import { QuestionSalesTerm as Question } from "@/components/features/items/edit/_shared/ui/components/main/questions/sales-term";

import { useOptionSalesTerm } from "./hooks";

export const QuestionSalesTerm = () => {
	const {
		isEdited,
		hasError,

		isLimitedSale,

		saleTypeForTerm,
		saleTypeForTermOptions,
		onSetSaleTypeForTerm,

		saleStart,
		saleEnd,
		onSetSaleTerm,

		stayableStart,
		stayableEnd,
		onSetStayableTerm,
	} = useOptionSalesTerm();

	const title = "販売期間";
	const guide =
		"オプションの販売期間を設定しましょう。<br />期間限定を選択した場合、公開期間中に予約された宿泊可能期間に滞在する予約でのみオプションが購入可能になります。<br />こちらの設定は在庫設定で上書き可能です。";

	return (
		<Question
			title={title}
			guide={guide}
			saleTypeForTerm={saleTypeForTerm}
			saleTypeForTermOptions={saleTypeForTermOptions}
			onSetSaleTypeForTerm={onSetSaleTypeForTerm}
			saleStart={saleStart}
			saleEnd={saleEnd}
			onSetSaleTerm={onSetSaleTerm}
			stayableEnd={stayableEnd}
			stayableStart={stayableStart}
			onSetStayableTerm={onSetStayableTerm}
			isEdited={isEdited}
			isLimitedSale={isLimitedSale}
			hasError={hasError}
		/>
	);
};

QuestionSalesTerm.displayName = "QuestionSalesTerm";
